import { evolutionPathPair } from "../../evolutions/evolutionPath";
import axios from "../api";
/**
 * The evolutions the player could apply next, given the chain so far.
 *
 * `filters` is required by the endpoint but every field on it is optional, so
 * a builder without a filter UI sends `{}`.
 */
export const getEvolutionSteps = async ({ resourceId, currentChain, currentPathwayChain, assetId, evoPathId, playerRoleIds, includedEvolutions, filters = {}, }) => {
    const body = {};
    if (currentChain.length > 0) {
        // The backend requires the pair together.
        const { evolutionPath, pathwayPath } = evolutionPathPair(currentChain, currentPathwayChain);
        body.evoPath = evolutionPath;
        body.pathwayPath = pathwayPath;
    }
    if (evoPathId)
        body.evoPathId = evoPathId;
    if (playerRoleIds?.length)
        body.playerRoleIds = playerRoleIds;
    if (assetId)
        body.assetId = assetId;
    if (includedEvolutions?.length)
        body.includedEvos = includedEvolutions;
    const res = await axios.post(`/players/${resourceId}/next-evo-steps/one-steps`, { ...body, filters: filters ?? {}, v: 2 });
    return res.data;
};
//# sourceMappingURL=getEvolutionSteps.js.map